import IconTrash from '@components/icons/IconTrash';
import { $editingMapMarkerApi } from '@stores/editingMarkerStores';
import type { STMapMarker } from '@types';
import { SortableElement } from 'react-sortable-hoc';
import { stEditorAmap } from '../STAMap';
import { deleteMarkers } from '../actions/deleteMarkers';
import { MapMarkerIcon } from '../components/MarkerIcon';
import { MapMarkerSubtitle } from '../components/MarkerSubtitle';

interface Props {
  marker: STMapMarker;
  sandTableId: string;
  listIndex: number;
}

function Item({ marker, sandTableId, listIndex }: Props) {
  const { title, id } = marker;

  const handleDelete = () => {
    deleteMarkers({ sandTableId, markerIds: id });
    stEditorAmap.removeMarker(id);
  };

  const handleClick = () => {
    $editingMapMarkerApi.set({ marker });
    stEditorAmap.centerMarker(marker);
  };

  return (
    <div
      className="mb-10 flex h-35 w-full cursor-pointer items-center rounded bg-black-#34 px-10 hover:bg-black-#45 select-none"
      onClick={handleClick}
    >
      <MapMarkerIcon marker={marker} />
      <div className="mx-10 truncate text-base text-white" title={title}>
        {title}
      </div>
      <MapMarkerSubtitle className="ml-auto" marker={marker} />
      <IconTrash
        className="ml-10 shrink-0"
        onClick={(e) => {
          e.stopPropagation();
          handleDelete();
        }}
      />
    </div>
  );
}

export default SortableElement(Item);
